type WindowWithZendesk = Window &
    typeof globalThis & {
        zE: (
            method: string,
            action: string,
            callback: (cb: (token: string) => void) => void,
        ) => void;
    };

export type TApiZendesk = ReturnType<typeof createApiZendesk>;

type TResponseZendesk = {
    token: string;
};

export const createApiZendesk = ({
    getAuth0Token,
    enabled,
    prodaBaseUrl,
}: {
    getAuth0Token: () => Promise<string>;
    enabled: boolean;
    prodaBaseUrl: string;
}) => ({
    initZendesk: async () => {
        if (!enabled) {
            console.debug(
                "Skipping Zendesk init: third-party tools are disabled.",
            );
            return;
        }
        const auth0Token = await getAuth0Token();
        const response = await fetch(`${prodaBaseUrl}/zendesk/jwt`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${auth0Token}`,
            },
        });

        if (!response.ok) {
            console.error(
                "Failed getting the zendesk token.",
                "The zendesk experience might be degraded, but you can still use it.",
                "The zendesk response was:",
                response,
            );
            return;
        }

        const result = (await response.json()) as TResponseZendesk;
        if (!result.token) {
            console.error(
                "Failed parsing the zendesk token.",
                "The zendesk experience might be degraded, but you can still use it.",
            );
            return;
        }

        (window as WindowWithZendesk).zE(
            "messenger",
            "loginUser",
            function (callback: (token: string) => void) {
                callback(result.token);
            },
        );
        (window as WindowWithZendesk).zE("messenger:on", "close", () => {
            (window as WindowWithZendesk).zE("messenger", "hide", () => {});
        });
        (window as WindowWithZendesk).zE("messenger", "hide", () => {});
    },
});
